export function getTextareaPresidence(question) {
  return question && question.textareaPresidence
    ? question.textareaPresidence
    : question.presidence;
}
